import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/contact.css';

import breadcrumbBg from '../assets/img/bg/breadcrumb-bg.png';
import cloudIcon from '../assets/img/icons/cloud.png';
import balloonIcon from '../assets/img/icons/ballon-sclation.png';

const Contact = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: ''
    });

    const [formErrors, setFormErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (formErrors[name]) {
            setFormErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const errors = {};

        if (!formData.firstName.trim()) {
            errors.firstName = 'First name is required';
        }

        if (!formData.lastName.trim()) {
            errors.lastName = 'Last name is required';
        }

        if (!formData.email.trim()) {
            errors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = 'Email is invalid';
        }

        if (!formData.phone.trim()) {
            errors.phone = 'Phone number is required';
        } else if (!/^\d{10,15}$/.test(formData.phone.replace(/\D/g, ''))) {
            errors.phone = 'Phone number is invalid';
        }

        if (!formData.message.trim()) {
            errors.message = 'Message is required';
        } else if (formData.message.trim().length < 10) {
            errors.message = 'Message must be at least 10 characters long';
        }

        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        setIsSubmitting(true);
        setFormErrors({});

        try {
            await new Promise(resolve => setTimeout(resolve, 2000));
            console.log('Form submitted:', formData);
            setSubmitMessage('Thank you for your message! We will get back to you soon.');
            setFormData({
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                message: ''
            });
        } catch (error) {
            setSubmitMessage('Sorry, there was an error sending your message. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="contact-page">
            {/* Breadcrumb Section with imported images */}
            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: `url(${breadcrumbBg})` }}
            >
                <img
                    src={cloudIcon}
                    alt="cloud icon"
                    className="vs-breadcrumb-icon-1 animate-parachute"
                />
                <img
                    src={balloonIcon}
                    alt="balloon icon"
                    className="vs-breadcrumb-icon-2 animate-parachute"
                />
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">Reach us</h1>
                            </div>
                            <div className="breadcrumb-menu">
                                <ul className="custom-ul">
                                    <li>
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li>Reach Us</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="vs-contact space">
                <div className="container">
                    <div className="row g-4 gx-xl-5 overflow-hidden">
                        <div className="col-lg-5">
                            <div className="title-area text-start mb-2">
                                <span className="sec-subtitle style-2">contact us</span>
                                <h2 className="sec-title">Get in touch with us</h2>
                            </div>
                            <div className="vs-contact-info mt-3 mb-2">
                                <p>
                                    <span className="text-theme-color fw-bold">Address:</span> Smart Avenue unit F0-02
                                    4th Floor, 28/A 80 Feet Road,
                                    Michael Palya, Indiranagar
                                    Bangalore - 560038
                                </p>
                                <div className="vs-contact-list">
                                    <div className="contact-item">
                                        <span className="icon">
                                            <i className="fa-solid fa-phone-volume"></i>
                                        </span>
                                        <div className="info">
                                            <h6 className="info-title">Customer Service :</h6>
                                            <p>
                                                <a href="tel:8317447895">83174 47895</a> ,
                                                <a href="tel:8317447895">83174 47895</a>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="contact-item">
                                        <span className="icon">
                                            <i className="fa-light fa-envelope"></i>
                                        </span>
                                        <div className="info">
                                            <h6 className="info-title">careers :</h6>
                                            <p>
                                                <a href="mailto:Booking@ascendtravelsolutions.in">Booking@ascendtravelsolutions.in</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="social-follow">
                                    <span>Follow Us :</span>
                                    <ul className="custom-ul">
                                        <li>
                                            <a href="https://x.com/" target="_blank" rel="noopener noreferrer">
                                                <i className="fa-brands fa-x-twitter"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                                                <i className="fa-brands fa-instagram"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fa-brands fa-linkedin-in"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fa-brands fa-vimeo-v"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-7">
                            <form className="form-style1" onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-6 form-group">
                                        <input
                                            name="firstName"
                                            type="text"
                                            className={`form-control ${formErrors.firstName ? 'is-invalid' : ''}`}
                                            placeholder="First Name*"
                                            value={formData.firstName}
                                            onChange={handleChange}
                                            disabled={isSubmitting}
                                        />
                                        {formErrors.firstName && (
                                            <div className="invalid-feedback">{formErrors.firstName}</div>
                                        )}
                                    </div>
                                    <div className="col-md-6 form-group">
                                        <input
                                            name="lastName"
                                            type="text"
                                            className={`form-control ${formErrors.lastName ? 'is-invalid' : ''}`}
                                            placeholder="Last Name*"
                                            value={formData.lastName}
                                            onChange={handleChange}
                                            disabled={isSubmitting}
                                        />
                                        {formErrors.lastName && (
                                            <div className="invalid-feedback">{formErrors.lastName}</div>
                                        )}
                                    </div>
                                    <div className="col-md-6 form-group">
                                        <input
                                            name="email"
                                            type="email"
                                            className={`form-control ${formErrors.email ? 'is-invalid' : ''}`}
                                            placeholder="Your Email*"
                                            value={formData.email}
                                            onChange={handleChange}
                                            disabled={isSubmitting}
                                        />
                                        {formErrors.email && (
                                            <div className="invalid-feedback">{formErrors.email}</div>
                                        )}
                                    </div>
                                    <div className="col-md-6 form-group">
                                        <input
                                            name="phone"
                                            type="tel"
                                            className={`form-control ${formErrors.phone ? 'is-invalid' : ''}`}
                                            placeholder="Your Phone*"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            disabled={isSubmitting}
                                        />
                                        {formErrors.phone && (
                                            <div className="invalid-feedback">{formErrors.phone}</div>
                                        )}
                                    </div>
                                    <div className="col-12 form-group">
                                        <textarea
                                            name="message"
                                            className={`form-control ${formErrors.message ? 'is-invalid' : ''}`}
                                            placeholder="Your Message..."
                                            rows="6"
                                            value={formData.message}
                                            onChange={handleChange}
                                            disabled={isSubmitting}
                                        ></textarea>
                                        {formErrors.message && (
                                            <div className="invalid-feedback">{formErrors.message}</div>
                                        )}
                                    </div>
                                    <div className="col-12 form-group mt-2 mb-0">
                                        <button
                                            type="submit"
                                            className="vs-btn"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Sending...
                                                </>
                                            ) : (
                                                'Send Message'
                                            )}
                                        </button>
                                    </div>

                                    {submitMessage && (
                                        <div className={`alert ${submitMessage.includes('error') ? 'alert-danger' : 'alert-success'} mt-3`}>
                                            {submitMessage}
                                        </div>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            <div className="map-layout1">
                <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3942.3735854313923!2d77.64140896364006!3d12.980994755130056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae175582d5a0e5%3A0xdb9ca11dc9ef1ca8!2sSMART%20OHM!5e0!3m2!1sen!2sin!4v1763447775084!5m2!1sen!2sin"
                    width="600"
                    height="450"
                    style={{ border: 0 }}
                    allowFullScreen="" 
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Ascend Travel Solutions Location"
                ></iframe>
            </div>
        </div>
    );
};

export default Contact;